import {
    ALL_GENDER_OPTIONS,
    ALL_GRADE_OPTIONS,
    STATUS,
    TEAM_ROLE,
    TEAM_ROLE_OPTIONS,
} from '@type/db-types';

export const statusKeyToLabel = (status: STATUS) =>
    `${status[0].toUpperCase()}${status.slice(1).toLowerCase()}`;

export const STATUS_LOOKUP = {
    [STATUS.ACTIVE]: statusKeyToLabel(STATUS.ACTIVE),
    [STATUS.CANCELLED]: statusKeyToLabel(STATUS.CANCELLED),
    [STATUS.DECLINED]: statusKeyToLabel(STATUS.DECLINED),
    [STATUS.INVITED]: statusKeyToLabel(STATUS.INVITED),
    [STATUS.LEFT]: statusKeyToLabel(STATUS.LEFT),
    [STATUS.PENDING]: statusKeyToLabel(STATUS.PENDING),
    [STATUS.REMOVED]: statusKeyToLabel(STATUS.REMOVED),
};

export const roleKeyToLabel = (role: string) =>
    TEAM_ROLE_OPTIONS.find((r) => r.value === role)?.label ||
    `${role[0].toUpperCase()}${role.slice(1).toLowerCase()}`;

export const TEAM_ROLE_LOOKUP = {
    [TEAM_ROLE.ATHLETE]: roleKeyToLabel(TEAM_ROLE.ATHLETE),
    [TEAM_ROLE.COACH]: roleKeyToLabel(TEAM_ROLE.COACH),
    [TEAM_ROLE.OWNER]: roleKeyToLabel(TEAM_ROLE.OWNER),
    [TEAM_ROLE.PARENT]: roleKeyToLabel(TEAM_ROLE.PARENT),
};

export const GENDER_LOOKUP = ALL_GENDER_OPTIONS.reduce(
    (acc, { label, value }) => ({
        ...acc,
        [value]: `${label[0].toUpperCase()}${label.slice(1).toLowerCase()}`,
    }),
    {},
);

export const GRADE_LOOKUP = ALL_GRADE_OPTIONS.reduce(
    (acc, { label, value }) => ({
        ...acc,
        [value]: label,
    }),
    {},
);
